import { apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

export const categoriesApi = {
  listEventCategories: () => apiGet<{ data: Record<string, unknown>[] }>(`/categories/events`),

  createEventCategory: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`/categories/events`, body),

  updateEventCategory: (id: string, body: Record<string, unknown>) => apiPut<{ data: Record<string, unknown> }>(`/categories/events/${id}`, body),

  deleteEventCategory: (id: string) => apiDelete<{ data: Record<string, unknown> }>(`/categories/events/${id}`),

  listBlogCategories: () => apiGet<{ data: Record<string, unknown>[] }>(`/categories/blogs`),

  createBlogCategory: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`/categories/blogs`, body),

  updateBlogCategory: (id: string, body: Record<string, unknown>) => apiPut<{ data: Record<string, unknown> }>(`/categories/blogs/${id}`, body),

  deleteBlogCategory: (id: string) => apiDelete<{ data: Record<string, unknown> }>(`/categories/blogs/${id}`),

  listDiscussionCategories: () => apiGet<{ data: Record<string, unknown>[] }>(`/categories/discussions`),

  createDiscussionCategory: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`/categories/discussions`, body),

  updateDiscussionCategory: (id: string, body: Record<string, unknown>) => apiPut<{ data: Record<string, unknown> }>(`/categories/discussions/${id}`, body),

  deleteDiscussionCategory: (id: string) => apiDelete<{ data: Record<string, unknown> }>(`/categories/discussions/${id}`),

  bulkDeleteEventCategories: (ids: string[]) => apiDelete<{ data: number }>(`/categories/events/bulk-delete`, { data: { ids } }),

  bulkDeleteBlogCategories: (ids: string[]) => apiDelete<{ data: number }>(`/categories/blogs/bulk-delete`, { data: { ids } }),

  bulkDeleteDiscussionCategories: (ids: string[]) => apiDelete<{ data: number }>(`/categories/discussions/bulk-delete`, { data: { ids } }),

  getStats: () => apiGet<{ data: Record<string, unknown> }>(`/categories/stats`),

  export: (type = "events", format = "CSV") => apiGet<{ data: unknown }>(`/categories/export?type=${type}&format=${format}`),
};